var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12695 12.7729C6.37753 12.799 6.61195 12.9018 6.80176 13.064L6.89355 13.1499L6.97461 13.2437C7.15372 13.4715 7.25 13.7543 7.25 14.0435C7.24998 14.2284 7.21086 14.4115 7.13477 14.5796L7.0459 14.7427C6.94532 14.8997 6.81154 15.0333 6.65332 15.1323L6.4873 15.2192C6.31368 15.2943 6.12591 15.3283 5.93848 15.3188L5.75098 15.2944C5.5655 15.2559 5.39344 15.1758 5.24609 15.062L5.10645 14.937C4.97703 14.8019 4.8802 14.6407 4.82031 14.4663L4.77344 14.2876C4.72719 14.045 4.75047 13.7931 4.8418 13.563L4.92188 13.396C5.01399 13.2358 5.14085 13.0963 5.29492 12.9888L5.45703 12.8931C5.62479 12.8104 5.8101 12.7661 6 12.7661L6.12695 12.7729Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.002 12.7729C13.2525 12.799 13.487 12.9018 13.6768 13.064L13.7686 13.1499L13.8496 13.2437C14.0287 13.4715 14.125 13.7543 14.125 14.0435C14.125 14.2284 14.0859 14.4115 14.0098 14.5796L13.9209 14.7427C13.7868 14.952 13.5935 15.1192 13.3623 15.2192C13.1887 15.2943 13.0009 15.3283 12.8135 15.3188L12.626 15.2944C12.4405 15.2559 12.2684 15.1758 12.1211 15.062L11.9814 14.937C11.8088 14.7569 11.6947 14.5302 11.6484 14.2876C11.6022 14.045 11.6255 13.7931 11.7168 13.563L11.7969 13.396C11.889 13.2358 12.0159 13.0963 12.1699 12.9888L12.332 12.8931C12.4998 12.8104 12.6851 12.7661 12.875 12.7661L13.002 12.7729Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H3.5L5.175 9.73261C5.23215 10.0329 5.38869 10.3026 5.61722 10.4945C5.84574 10.6865 6.13169 10.7885 6.425 10.7826H12.5C12.7933 10.7885 13.0793 10.6865 13.3078 10.4945C13.5363 10.3026 13.6928 10.0329 13.75 9.73261L14.75 4.26087H4.125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 9 9)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAdd);
export default __webpack_public_path__ + "static/media/cart_add.8cf24d434d194a02e8360313423fd195.svg";
export { ForwardRef as ReactComponent };